import { gql } from '@apollo/client';

export const fetchShippingAddressesForTransactionAccount = gql`
  query fetchShipToPartiesForTransactionAccount($id: ID!) {
    transactionAccount(id: $id) {
      id
      availableShipToParties {
        totalCount
        nodes {
          name
          id
          addressLine1
          addressLine2
          city
          state
          country
          postcode
          taxId
          taxIds {
            id
            label
            metadata {
              vatStatus
            }
            taxExempt
          }
          taxLabels {
            region
            taxIdLabels {
              description
              displayName
              type
              metadata {
                type
                labels {
                  default
                  label
                  vatStatus
                }
              }
            }
          }
          shipToPriceEligibility
          taxExempt
          hasLinkedSubscriptions
        }
      }
    }
  }
`;
